'use client';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button } from '@mui/material';
import Container from '@mui/material/Container';
import React, { FC, useState } from 'react';

import { SidebarProps } from '../types';
import { LargeSidebarLogo, SmallSidebarLogo } from './SidebarLogo';
import SidebarNav from './SidebarNav';

export const Sidebar: FC<SidebarProps> = ({
	theme,
	SmallLogo = SmallSidebarLogo,
	LargeLogo = LargeSidebarLogo,
	NavComponent = SidebarNav,
	tenantPortal,
	navLinks,
}) => {
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const [sidebarOpenFromButton, setSidebarOpenFromButton] = useState(false);
	const handleMouseEnter = (e: any) => {
		if (e.target.id === 'close-icon') {
			return;
		}
		if (e.target.id !== 'pca__sidebar-open-close-btn') {
			if (e.target.id !== 'open-icon') {
				setSidebarOpen(true);
			}
		}
	};

	const handleMouseLeave = () => {
		if (!sidebarOpenFromButton) {
			setSidebarOpen(false);
		}
	};

	return (
		<Container
			id='pca__sidebar'
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			style={{
				width: sidebarOpen && tenantPortal ? '200px' : sidebarOpen ? '170px' : '55px',
				transition: 'width 0.3s ease',
				overflowY: 'scroll',
				height: '100vh',
				zIndex: 1,
			}}
		>
			<div id='pca__sidebar--small-logo' style={{ display: sidebarOpen ? 'none' : 'block' }}>
				<SmallLogo theme={theme} />
			</div>
			<div id='pca__sidebar--large-logo' style={{ display: sidebarOpen ? 'block' : 'none' }}>
				<LargeLogo theme={theme} />
			</div>
			<NavComponent sidebarOpen={sidebarOpen} theme={theme} {...(navLinks && { navLinks })} />
			<Button
				onClick={(e) => {
					e.stopPropagation();
					setSidebarOpen(!sidebarOpen);
					setSidebarOpenFromButton(!sidebarOpenFromButton);
				}}
				id='pca__sidebar-open-close-btn'
				size='small'
				color='primary'
				style={{
					left: sidebarOpen ? '155px' : '40px',
				}}
			>
				{!sidebarOpen ? (
					<ArrowForwardIosIcon
						id='open-icon'
						fontSize='small'
						style={{ marginLeft: '1px', color: 'white' }}
					/>
				) : (
					<ArrowBackIosIcon id='close-icon' style={{ marginLeft: '7px', color: 'white' }} fontSize='small' />
				)}
			</Button>
			{sidebarOpen && theme.platformName.name !== '' && (
				<div style={{ marginTop: '30px', opacity: '0.5' }}>
					<hr
						style={{
							border: 'none',
							height: '1px',
							backgroundColor: theme.sidebar.color,
						}}
					/>
					<div
						style={{
							textAlign: 'center',
							color: theme.sidebar.color,
							padding: '8px 0px',
						}}
					>
						{theme.platformName.name}
					</div>
					<hr
						style={{
							border: 'none',
							height: '1px',
							backgroundColor: theme.sidebar.color,
						}}
					/>
				</div>
			)}
		</Container>
	);
};
